<template>
  <div :key="rerenderKey" style="display:inline-block; margin: 0px 10px;">
    <!-- <el-upload
      :multiple="true"
      action="#"
      :before-upload="SubmitPicture"
      :show-file-list="true"
      :on-success="handleAvatarSuccess"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :before-remove="beforeRemove"
      :file-list="fileList"
      list-type="picture"
    >
      <el-tooltip class="item" effect="dark" content="Attach image" placement="top">
        <i v-if="this.picturesbeinguploaded == 0" class="far fa-image" style="font-size: 21px;  color:rgb(89, 89, 89);"></i>
        <i v-if="this.picturesbeinguploaded != 0" class="el-icon-loading" style="font-size: 21px;  color:rgb(89, 89, 89);"></i>
      </el-tooltip>
    </el-upload> -->
<div>
  <label for="image-input">
      <el-tooltip class="item" effect="dark" content="Attach image" placement="top">
        <i v-if="this.picturesbeinguploaded == 0" class="far fa-image" style="font-size: 21px;  color:rgb(89, 89, 89); cursor: pointer;"></i>
        <i v-if="this.picturesbeinguploaded != 0" class="el-icon-loading" style="font-size: 21px;  color:rgb(89, 89, 89);"></i>
      </el-tooltip>  </label>

  <input @input="SubmitPicture()" style="display: none;" id="image-input" name="attachments[]" ref="image-input" type="file" multiple/>
</div>

    <div v-for="img in this.imgList" :key="img.pictureid">
      <img :src="img.blob" class="finishedimage" />
      <i
        style="vertical-align: top;position: relative;
                left: -11px;
                bottom: 8px;
                color:rgb(89, 89, 89);"
        class="el-icon-error"
        @click="removeImageFromFormSubmit(img)"
      ></i>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
export default {
   props: {
     propertyid: String
  },
  data() {
    return {
      imgList: [],
      imageUrl: "",
      pictureIdList: [],
      picturesbeinguploaded: 0,
      pictureInfo: [],
      rerenderKey: 200
    };
  },
  methods: {



    SubmitPicture() {

        var filesInInput = this.$refs["image-input"].files;

        this.picturesbeinguploaded++;

             this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
    
        let picturedetailsobject = {
              imageinformation: []
          }; 

        var filesArray = Array.from(filesInInput); 
        
        for(var i = 0; i < filesArray.length; i++){
          
          var file = filesArray[i];
          if (
              file.type != "image/jpeg" &&
              file.type != "image/png" &&
              file.type != "image/gif" &&
              file.type != "image/bmp" &&
              file.type != "image/tif"
            ) {
                   this.picturesbeinguploaded = 0;

         if(this.$route.fullPath.includes("tab1")){
                 this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
          } else{
                   this.$emit("pictureuploadstatusissues", this.picturesbeinguploaded);
          }                
                   this.$store.dispatch("addNotification", {
                        type: "error",
                        Message: "This is not a supported file type"
                    });
                return;
                  }
               };

        filesArray.forEach(file => {

            const MaxContentLength = 1024 * 1024 * 10;
            
            if (file.size > MaxContentLength) {
              return  this.$store.dispatch("addNotification", {
                          type: "error",
                          Message: "This is not a supported file type"
                      });
            }

            picturedetailsobject.imageinformation.push({
                contenttype: file.type,
                filename: file.name,
                //should be null for certain picture uploads
                propertyid: this.propertyid
            })
        });



      let presignedurlholder = " presign default";
      let pictureidholder = "";
      let cacheTime = null;

      EventService.GenerateImageObjectSpaceOnAws(picturedetailsobject)
        .then(response => {

            response.data.imageinformationtoreturn.forEach(imgInfoObject => {
              
                this.pictureIdList.push(imgInfoObject.pictureid);
                presignedurlholder = imgInfoObject.presignedurl;
                cacheTime = imgInfoObject.cachetime;

                // here get the file object from the file array which belongs to the picture id of the current
                // id in the API return array of id's
                var file = filesArray.filter( i => i.name == imgInfoObject.oldfilename)[0];

                this.imgList.push(
                  {blob : URL.createObjectURL(file), 
                   pictureid: imgInfoObject.pictureid}
                  );

                EventService.uploadPictureToAws(
                  presignedurlholder,
                  file,
                  file.type,
                  cacheTime
                ).then(() => {
                      this.pictureInfo = [imgInfoObject, picturedetailsobject]
                            if(this.$route.fullPath.includes("tab1")){

                    this.$emit("picture-id", this.pictureInfo);
                            } else {
                       this.$emit("picture-id-issues", this.pictureInfo);

                            }
                      this.$emit("displaypicturelocally", URL.createObjectURL(file));
                });
            });

            this.picturesbeinguploaded--;

            if(this.$route.fullPath.includes("tab1")){

              this.$emit("pictureuploadstatus", this.picturesbeinguploaded);
            } else {
              this.$emit("pictureuploadstatusissues", this.picturesbeinguploaded);

            }
       });
    },
    removeImageFromFormSubmit(img) {
      console.log("this is the img" + img);
      this.$delete(this.imgList, this.imgList.indexOf(img));

      var currentImageId = this.pictureIdList.filter( id => id == img.pictureid)[0];

        if(this.$route.fullPath.includes("tab1")){


      this.$emit("removePictureId", currentImageId);
        } else {
                this.$emit("removePictureIdIssues", currentImageId);
        }
    },
  }
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 200px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.thumb {
  width: 178px;
  height: 178px;
  display: block;
}
.finishedimage {
  height: 75px;
  margin: 3px;
  border-radius: 3px;
  object-fit: cover;
}

.flexcontainer {
  display: flex;
  flex-wrap: wrap;
}
.el-icon-paperclip {
  font-size: 22px;
}
</style>
